import { logToServer } from './logger-client';

// Create agent-specific logger
class AgentLogger {
  private requestId: string;
  private section: string;

  constructor(section: string = 'agent') {
    this.requestId = Math.random().toString(36).substring(7);
    this.section = section;
  }

  private formatMessage(message: string) {
    return `[${this.requestId}] ${message}`;
  }

  debug(message: string, data?: any) {
    logToServer('debug', this.section, this.formatMessage(message), data);
  }

  info(message: string, data?: any) {
    logToServer('info', this.section, this.formatMessage(message), data);
  }

  warn(message: string, data?: any) {
    logToServer('warn', this.section, this.formatMessage(message), data);
  }

  error(message: string, data?: any) {
    logToServer('error', this.section, this.formatMessage(message), data);
  }
}

export const agentLogger = new AgentLogger();
export { AgentLogger };
